<template>
  <div class="highscore">
    <h2>Highscore</h2>

    <div class="scores">
      <div class="highscore-row" :class="{'me': highscore[0] === playerName}" v-for="(highscore, index) in list">
        <div class="number" v-if="index >= 3">{{parseFloat(index)+1}}.</div>
        <div class="number" :class="`trophy${index}`" v-if="index < 3">
          <i class="fa fa-trophy"></i>
        </div>
        <div class="name">{{highscore.name.name}}</div>
        <div class="score">{{highscore.score | format}}</div>
      </div>
    </div>
    <div class="menu-bar">
      <span @click="view = 'score'" :class="{'active': view === 'score'}">Highest score</span>
      <span @click="view = 'played'" :class="{'active': view === 'played'}">Most played</span>
    </div>
  </div>
</template>

<script>
import accounting from 'accounting';

export default {
  name: 'highscore',
  props: ['client', 'highscoreRoom', 'playerName', 'highscores', 'plays'],
  filters: {
    format(value) {
      return accounting.formatNumber(value);
    },
  },
  data() {
    return {
      view: 'score',
    };
  },
  computed: {
    list() {
      if (this.view === 'score') return this.highscores;
      return this.plays;
    },
  },
};
</script>

<style lang="less">
@import (reference) '~@/styles/colors.less';

.highscore {
  padding: 2rem;
  display: flex;
  height: 100%;
  flex-direction: column;
  position: relative;

  .menu-bar {
    position: absolute;
    bottom: 1.5rem;
    background: #262626;
    text-align: center;
    left: 0;
    right: 0;

    span {
      display: inline-block;
      padding: 0.5rem;
      cursor: pointer;
      &.active {
        font-weight: bold;
      }
    }
  }

  h2 {
    margin-bottom: 2rem;
  }

  .scores {
    flex-grow: 2;
    overflow-y: auto;
    padding-right: 1rem;
    padding-bottom: 2.5rem;

    &::-webkit-scrollbar {
      width: 1px;
      height: 9px;
    }
    &::-webkit-scrollbar-button:start:decrement,
    &::-webkit-scrollbar-button:end:increment {
      display: block;
      height: 0;
      background-color: transparent;
    }
    &::-webkit-scrollbar-track-piece {
      background-color: rgba(0, 0, 0, 0.3);
      -webkit-border-radius: 0;
    }
    &::-webkit-scrollbar-thumb:vertical {
      height: 50px;
      background-color: @pink;
    }
    &::-webkit-scrollbar-thumb:horizontal {
      width: 50px;
      background-color: @pink;
    }
  }

  .footer {
    padding-top: 1rem;
  }

  button {
    margin: 0;
  }

  .highscore-row {
    display: flex;
    align-items: center;
    div {
      // flex: 1;
      &.name {
        flex-grow: 2;
      }

      &.number {
        margin-right: 0.5rem;
      }

      &.score {
        font-size: 2rem;
      }
    }
    &.me {
      font-weight: bold;
    }
  }

  .trophy0 {
    color: gold;
  }
  .trophy1 {
    color: silver;
  }
  .trophy2 {
    color: brown;
  }
}
</style>



// WEBPACK FOOTER //
// Highscore.vue?8c31dcfa